module.exports = __webpack_public_path__ + "static/media/salisbury-13.c0422cca.jpg";